import React, { useState } from 'react';
import logoEditar from '../assets/logoEditar.png';
import { FiltrosAdmin } from './FiltrosAdmin.js';
import { TablaN } from './TablaN.js';
import { useAdminUsers } from '../hooks/useAdminUsers.jsx';
import { useCompaniesQuery } from '../hooks/useCompaniesQuery.jsx';
import { AdminUserModals } from './AdminUserModals.jsx';
import { CompanyActions } from './CompanyActions.jsx';

export const EmpresasAdminN = ({search, setShowedModals}) => {
    const { companies, loading, updateCompany } = useCompaniesQuery("empresa/todasLasEmpresas", { size: 100000 });
    const admin = useAdminUsers({ onUpdateCompany: updateCompany });
    const selectedCompany = companies?.find(
        c => c.id === admin.idElemSeleccionado
    ) || admin.profilePlaceholder;
    
    const [tipoEvaluar, setTipoEvaluar] = useState("0");
    const [tipoMora, setTipoMora] = useState("0");
    const [union, setUnion] = useState("0");

    const itemsFiltro = [
        {
            setValue: setTipoEvaluar, value: tipoEvaluar, id: "tipoEvaluar", text: "Tipo de evaluación",
            items: ["Todas", "A evaluar", "Aprobadas", "Desaprobadas"]
        },
        {
            setValue: setTipoMora, value: tipoMora, id: "tipoMora", text: "Tipo de mora",
            items: ["Todas", "Con mora", "Sin mora"]
        },
        {
            setValue: setUnion, value: union, id: "uniones", text: "Tipo de unión",
            items: ["Todas", "Con mora", "Sin mora"], mostrarTodas: true, idSeccion: 0
        }
    ];
   
    function mostrarEmpresa(elem) {
        return ((tipoEvaluar === "0" || (tipoEvaluar === "1" && elem.estaAprobado === null)
            || (tipoEvaluar === "2" && elem.estaAprobado) || (tipoEvaluar === "3" && elem.estaAprobado === false))
            && (tipoMora === "0" || (tipoMora === "1" && elem.estaEnMora)
                || (tipoMora === "2" && !elem.estaEnMora)) && (union === "0" || union == elem.numeroUnion)) && 
                elem.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                        .includes(search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
    }

    const contentCompany = (elem) => {
        return (
            <>
                <div className='col-md-5 col-sm-6 col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                    {elem.nombre}
                </div>
                <div className='col-3 col-sm-2 text-center col-rubro ocultar740 ocultar392'>
                    <div className='ocultarMobile'>{elem.estaEnMora ? "Si" : "No"}</div>
                    <div className='mostrarMobile d-none'>{elem.estaEnMora ? "Con Mora" : "Sin Mora"}</div>
                </div>
                <div className='col-4 col-sm-2 px-0 text-center col-rubro col-740-3 col-392 ocultar-901-680  d-sm-none d-md-block'>
                    {elem.estaAprobado ? "Aprobado" : elem.estaAprobado === null ? "Pendiente" : "Desaprobado"}
                </div>
                <div className='col col-sm text-end col-rubro text-center-901-400'>
                    <CompanyActions
                        company={elem}
                        isLoading={admin.isLoading}
                        onApprove={(id) => admin.evaluarUsuario(id, true)}
                        onSelect={admin.setIdElemSeleccionado}
                    />
                    <div id="dropdownConfigFixedAdmin" class="dropdown d-inline-block " >
                        <img className='ms-3 cursor-pointer img-blanco-mobile' src={logoEditar} alt="" data-bs-toggle="dropdown" aria-expanded="false" />

                        <ul class="dropdown-menu rounded-3">
                            <li>
                                <button class="btn btn-outline-primary bold-botones btn-cuadrado me-3  btn-verperfil-empresas "
                                    onClick={() => admin.modificarMora(elem.id, !elem.estaEnMora)}>
                                    {elem.estaEnMora ? 'Remover Mora' : 'Agregar Mora'}
                                </button>

                                <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal"
                                    data-bs-target="#modalCambiarUnion" onClick={() => admin.setIdElemSeleccionado(elem.id)}>Modificar Unión</button>

                                <div className="cruzMenuConfiguracion" alt="" />

                            </li>

                        </ul>
                    </div >
                </div>
            </>
        );
    };

    return (

        <>
            <FiltrosAdmin itemsFiltro={itemsFiltro} setShowedModals={setShowedModals}/>

            <TablaN elementos={companies}
                itemsEncabezado={[
                    { className: 'col-md-5 col-6', text: 'Empresas' },
                    { className: 'col-2 text-center ocultar740', text: 'Mora' },
                    { className: 'col-2 text-center col-740-3 ocultar-901-680  d-sm-none d-md-block', text: 'Estado' },
                    { className: 'col text-center', text: '' }
                ]} ocultarEncabezadoMobile={true}
                itemsFilas={contentCompany} elemNoEncontrado={'empresas'}
                mostrarElem={mostrarEmpresa} mostrarLoader={loading} />
            
            <AdminUserModals {...admin} perfil={selectedCompany} />

        </>
    );
}

